import _ from 'lodash';
import {useTranslation} from 'react-i18next';
import i18n from 'i18next';
import {useEffect, useState} from 'react';
import {TextLinkButton} from '../components/Button';
import PageSection from '../components/PageSection';
import SectionTitle from '../components/SectionTitle';
import NewsArticle from '../components/NewsArticle';
import Quotes from '../components/Quotes';
import Quote from '../components/Quote';
import NewsBanner from '../components/NewsBanner';
import {NodesMap} from '../components/NodesMap';
import HeroSection from '../components/home/HeroSection';
import HowItWorksSection from '../components/home/HowItWorksSection';
import EnterpriseAIAgentsSection from '../components/home/EnterpriseAIAgentsSection';
import ReadyToBuildSection from '../components/home/ReadyToBuildSection';
import DownloadClientsSection from '../components/home/DownloadClientsSection';
import ValidatorPartnersSection from '../components/home/ValidatorPartnersSection';

import quoteLogosCAA from '../assets/logos/quotes/caa@2x.png';
import quoteLogosGoogle from '../assets/logos/quotes/google@2x.png';
import quoteLogosSony from '../assets/logos/quotes/sony@2x.png';
const HomePage = () => {
    const {t} = useTranslation();
    const [showAllNewsArticles, setShowAllNewsArticles] = useState(false);
    const [newsArticles, setNewsArticles] = useState([]);
    const featuresNewsArticle = _.first(newsArticles);
    const [customerLogos, setCustomerLogos] = useState([]);

    const fetchNewsArticles = async () => {
        const language = i18n.language;
        let url = 'https://theta-mkt-api.thetatoken.org/v1/sheet/theta-network-news';
        if (language === 'kr') {
            url = 'https://theta-mkt-api.thetatoken.org/v1/sheet/theta-network-news-korean';
        }
        const response = await fetch(url);
        setNewsArticles(await response.json());
    };

    const fetchCustomerLogos = async () => {
        let url = 'https://theta-mkt-api.thetatoken.org/v1/sheet/edgecloud-customer-logos-carousel';
        const response = await fetch(url);
        setCustomerLogos(await response.json());
    };

    useEffect(() => {
        document.body.style.backgroundColor = '#09090D';

        fetchNewsArticles();
        fetchCustomerLogos();

        return () => {
            document.body.style.backgroundColor = null;
        };
    }, []);

    return (
        <div className={'Page HomePage'}>
            {
                featuresNewsArticle &&
                <NewsBanner {...featuresNewsArticle}/>
            }

            <HeroSection partnerLogos={customerLogos}/>

            <HowItWorksSection/>

            <EnterpriseAIAgentsSection/>

            <ReadyToBuildSection/>

            <div className={'MapAndNewsWrapper'}>
                <PageSection id={'live-nodes'} className={'NodesMapSection'}>
                    <SectionTitle title={t('home.live-nodes')} weight={600} center/>
                    <NodesMap/>
                </PageSection>

                <ValidatorPartnersSection/>

                {
                    !_.isEmpty(newsArticles) &&
                    <PageSection className={'NewsSection'}>
                        <SectionTitle title={t('home.recent-news')} weight={600} center/>
                        {/* <TextLinkButton className={'NewsSection__view-all-news'}
                                        onClick={() => {
                                            setShowAllNewsArticles(!showAllNewsArticles);
                                        }}
                        >
                            {!showAllNewsArticles && t('home.view-more-news')}
                            {showAllNewsArticles && t('home.view-less-news')}
                        </TextLinkButton> */}

                        <div className={'NewsArticles'}>
                            {
                                _.map(_.take(newsArticles, (showAllNewsArticles ? 100 : 12)), (newsArticle) => {
                                    return <NewsArticle {...newsArticle}/>;
                                })
                            }
                        </div>
                        <TextLinkButton className={'NewsSection__view-all-news'}
                                        onClick={() => {
                                            setShowAllNewsArticles(!showAllNewsArticles);
                                        }}
                        >
                            {!showAllNewsArticles && t('home.view-more-news')}
                            {showAllNewsArticles && t('home.view-less-news')}
                        </TextLinkButton>
                    </PageSection>
                }
            </div>

            <DownloadClientsSection/>

            <PageSection className={'QuotesSection'}>
                <Quotes center>
                    <Quote body={t('quotes.caa.body')}
                           name={t('quotes.caa.name')}
                           logo={quoteLogosCAA}
                           center
                    />
                    <Quote body={t('quotes.google.body')}
                           logo={quoteLogosGoogle}
                           center
                    />
                    <Quote body={t('quotes.sony.body')}
                           logo={quoteLogosSony}
                           center
                    />
                </Quotes>
            </PageSection>
        </div>
    );
};

export default HomePage;
